var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradebookNotPostedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 24,
    rx: 12,
    fill: "#F9E4F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19 17C19.5178 17 19.9375 16.5803 19.9375 16.0625C19.9375 15.5447 19.5178 15.125 19 15.125C18.4822 15.125 18.0625 15.5447 18.0625 16.0625C18.0625 16.5803 18.4822 17 19 17Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 13.25V12.625C20.3805 12.625 21.5 11.6453 21.5 10.4375C21.5 9.22969 20.3805 8.25 19 8.25C17.6195 8.25 16.5 9.22969 16.5 10.4375V10.75",
    stroke: "#344054",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 19.5C23.1421 19.5 26.5 16.1421 26.5 12C26.5 7.85786 23.1421 4.5 19 4.5C14.8579 4.5 11.5 7.85786 11.5 12C11.5 16.1421 14.8579 19.5 19 19.5Z",
    stroke: "#344054",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradebookNotPostedIcon);
export default __webpack_public_path__ + "static/media/gradebook-not-posted-icon.fe1e9d3ab2a9677d1b64be62ec88a834.svg";
export { ForwardRef as ReactComponent };